
const noStudyAssociatedErrorPageStyle = {
  rootBox: {
    maxWidth: 900,
    marginTop: -2,
    marginBottom: 4,
    marginLeft: -3,
    marginRight: 0,
    padding: 2,
    fontFamily: "Roboto, sans-serif",
  },

  firstPaper: {
    padding: 3,
    borderRadius: 2,
    marginBottom: 4,
    lineHeight: 1.6,
    width: "100%",
    maxWidth: "none",
    minWidth: 600,
  },

  secondPaper: {
    padding: 3,
    borderRadius: 2,
    lineHeight: 1.6,
  },
};

export default noStudyAssociatedErrorPageStyle;
